import { getAt } from '@finn-no/mobility-item-insertion-shared';
import { Toggle } from '@warp-ds/react';
import { Controller, type FieldError, useFormContext } from 'react-hook-form';
import type { BooleanWidgetModel } from '../../../types/widget.js';

type BooleanWidgetProps = Omit<BooleanWidgetModel, 'type'>;

// TODO: Move this "Controlled" part out - it seems to be a pattern that is repeated in all widgets
export const ControlledBooleanWidget = ({ name, helpText, ...props }: Omit<BooleanWidgetProps, 'onChange'>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getAt<FieldError>(errors, name);
  if (error) {
    helpText = (error.message as string) ?? 'Validation error';
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Toggle
          helpText={helpText}
          invalid={!!error}
          type="checkbox"
          label={props.label}
          checked={value === true}
          onChange={onChange}
          optional={!props.mandatory}
          data-testid={name}
          className={props.className}
        />
      )}
      rules={props.rules}
    />
  );
};
